import { Theme } from "@mui/material/styles";

export const styles = {
  actionsContainer: {
    flexDirection: "row",
    alignItems: "center",
    maxWidth: { xs: "100%", md: "55%" },
    minWidth: 0,
  },
  urlWrapper: {
    backgroundColor: (theme: Theme) => theme.colors.grey300,
    p: 2,
    borderRadius: "8px",
    height: "fit-content",
    overflow: "hidden",
  },
  actionIcon: {
    border: (theme: Theme) => `1px solid ${theme.colors.grey400}`,
    borderRadius: "8px",
    ml: 1,
    width: "56px",
    height: "56px",
  },
  hidden: {
    display: { xs: "none", md: "flex" },
  },
};
